import { authAxios } from "../utils/session_utils";

export const ItemTypes = {
    FOLDER: "folder",
    BOOKMARK: "bookmark",
};


export const fetchBookmarksFromDB = async () => {
	try {
		const response = await authAxios({
			method: "get",
			url: `${process.env.REACT_APP_BACK_END_API}/bookmarks`,
		});

		return response.data[0].BOOKMARKS;
	} catch (error) {
		console.error("Failed to fetch bookmarks:", error);
		return [];
	}
};